export const publicAccessType = 'Public';
export const privateAccessType = 'Private';
export const sharedAccessType = 'Shared';

export const LIST_SETTINGS_SAVE = 'list-forms.settings-save';
export const LIST_CREATE_WO_PRODUCTS = 'list-forms.create-without-products';
export const LIST_DELETE = 'list-forms.list-delete';
